import './index.css';
import Modal from 'components/Modal';
import { useState } from 'react';
import ProdutoService from '../../services/produtos.service';
import { toast } from 'react-hot-toast';


const ProdutoCreatorModal = ({ getList, closeModal }) => {
	const [nome, setProduto] = useState('');
	const [preco, setPreco] = useState('');
	const [descricao, setDescricao] = useState('');
	const [foto, setFoto] = useState('');

	const handleNewProduto = async () => {
		const novoProduto = {
			produto: nome,
			preco,
			descricao,
			foto,
		};
		const res = await ProdutoService.create(novoProduto);
		closeModal();
		getList();
	};

	return (
		<Modal closeModal={closeModal}>
			<div className='ProdutoCreatorsModal'>
				<div>
					<input type='text' value={nome} placeholder='Nome do produto' onChange={(e) => setProduto(e.target.value)} name='produto' />
					<input type='number' min='1' value={preco} placeholder='Preço do produto' onChange={(e) => setPreco(e.target.value)} name='preco' />
					<input type='text' value={descricao} placeholder='Descrição do produto' onChange={(e) => setDescricao(e.target.value)} name='preco' />
					<input type='text' value={foto} placeholder='Caminho de imagem' onChange={(e) => setFoto(e.target.value)} name='image' />
				</div>
				<div className='ProdutoCreatorsModal__Btns'>
					<span
						className='ProdutoCreatorsModal__editFancy'
						onClick={(e) => {
							e.stopPropagation();
							handleNewProduto();
						}}
					>
						✔️
					</span>
				</div>
				{/* <img className='ProdutoCreatorsModal__foto' src={produto.foto} alt={`Foto de ${produto.produto}`} /> */}
			</div>
		</Modal>
	);
};

export default ProdutoCreatorModal;
